import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UpdateTaskInput, UpdateTaskMutation } from '@/gql/graphql';

const UPDATE_TASK_MUTATION = graphql(`
  mutation UpdateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      ... on IEntity {
        id
      }
    }
  }
`);

const useUpdateTask = (
  options?: UseMutationOptions<UpdateTaskMutation, unknown, UpdateTaskInput>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_TASK_MUTATION, { input });
    },
    ...options,
  });
};

export default useUpdateTask;
